import { Component, inject } from "@angular/core";
import { HamburgerMenuComponent } from "../shared-components/hamburger-menu/hamburger-menu.component";
import { UserInfoDialogComponent } from "../shared-components/user-info-dialog/user-info-dialog.component";
import { LeftSidebarService } from "src/services/left-sidebar.service";
import { CommonModule } from "@angular/common";
import { EvMessageCenterComponent } from "ev-message-center";
import { MessageCenterStore } from "src/stores/message-center.store";
import { MessageCenterService } from "src/services/message-center.service";

@Component({
    selector: "app-base-page",
    imports: [HamburgerMenuComponent, UserInfoDialogComponent, CommonModule, EvMessageCenterComponent],
    templateUrl: "./base-page.component.html",
    styleUrls: ["./base-page.component.scss"],
})
export class BasePageComponent {
    leftSidebarVisible = inject(LeftSidebarService).isOpen;

    readonly messageCenterStore = inject(MessageCenterStore);
    private readonly messageCenterService = inject(MessageCenterService);

    updateReadMessages(toggledOpen: boolean) {
        if (toggledOpen) {
            this.messageCenterService.updateReadMessages();
        }
    }
}
